// §29.6 / §9.1 — Backgammon as an in-process app. The manifest only (D-247).
import type { InProcessApp, PlayShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createBackgammonApp(play: PlayShellAccess): InProcessApp {
  return createLazyApp<{ play: PlayShellAccess }>({
    app: {
      id: 'backgammon',
      name: 'Backgammon',
      icon: { glyph: 'dices', hue: 18 },
      keywords: ['backgammon', 'board', 'dice', 'cube', 'game', 'arcade'],
      category: 'Arcade',
      group: 'Boards',
      requiresAuth: true,
      window: { width: 1000, height: 720, minWidth: 640, minHeight: 480, multiWindow: false },
      jumpList: [{ id: 'new-game', label: 'New match' }],
    },
    load: () => import('./Backgammon'),
    props: { play },
  });
}
